import { ALERT_TYPE } from "components/common/Alert";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import { useStyles } from "components/request-document/components/Commons";
import UploadDucument from "components/request-document/components/UploadDucument";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import {
  REQUEST_DOCUMENT_STEP,
  VISA_TYPE_ID,
  VISA_TYPE_NAME,
} from "libs/configs/constant";
import { SMART_NAME_ALIAS, SMART_NAME_FULL } from "libs/constant/smartForm";
import { SMART_T_STEP } from "libs/constant/Step";
import useAlert from "libs/hooks/useAlert";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  getDocumentRequired,
  reqdoclogList,
  reqdoclogListSlice,
  selectReqdoclogList,
} from "redux/modules/visaForm";

export default function UploadDucumentStep() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [isSaveDraft, setSaveDraft] = useState(false);

  const { smartserviceId } = useSmartService();
  const { personalId } = usePersonalDetail();
  const {
    draftId,
    addSmartFormState,
    getSmartForm,
    isTypeChange,
    isExtension,
    isDepartmentRequestDoc,
    smartform,
    ConditionType,
  } = useSmartForm();
  const canEdit = useSelector(canEditForm);
  const { showLoading, hideLoading } = useModalLoading();
  const { showAlert, hideAlert } = useAlert();
  const reqdoclogListState = useSelector(selectReqdoclogList);
  const smartserviceReferId = get(smartform, "smartserviceReferId");

  const smartNameAlise = SMART_NAME_ALIAS[smartform?.smartserviceName];
  const smartNameFull = SMART_NAME_FULL[smartform?.smartserviceName];

  const isSmartS = smartserviceReferId === VISA_TYPE_ID.SMART_S;
  const refSmartNameAlias =
    SMART_NAME_ALIAS[VISA_TYPE_NAME[smartserviceReferId]];

  useEffect(() => {
    if (smartserviceId) {
      dispatch(
        getDocumentRequired({
          smartserviceId,
          ...(smartNameAlise === "S" ? { ConditionType: ConditionType } : {}),
          ...(isTypeChange && { ConditionType: "CHANGE" }),
          ...(isExtension && {
            smartserviceId: "ea67ab08-5953-4453-0830-28ed243a8d38",
            ConditionType: isSmartS ? ConditionType : refSmartNameAlias,
          }),
        })
      );
      if (isDepartmentRequestDoc) {
        dispatch(reqdoclogList({ draftId, status: "R" }));
      }
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
      });
    }
  }, [
    dispatch,
    draftId,
    getSmartForm,
    personalId,
    smartserviceId,
    isDepartmentRequestDoc,
  ]);

  useEffect(() => {
    if (!reqdoclogListState.isLoading) {
      if (reqdoclogListState.isSuccess) {
        if (reqdoclogListState.list.length === 0) {
          if (!isSaveDraft) {
            showAlert({
              type: ALERT_TYPE.SUCCESS,
              title: "Update complete",
              description: "You have been uploaded document successfully",
              button: [
                {
                  title: "Done",
                  onClick: () => {
                    hideAlert();
                    dispatch(setSmartFormStep(SMART_T_STEP.NONE));
                  },
                },
              ],
            });
          } else {
            getSmartForm({
              smartserviceId,
              draftId,
              personalId,
            });
          }
          dispatch(reqdoclogListSlice.actions.clearAsyncState());
        } else {
          getSmartForm({
            smartserviceId,
            draftId,
            personalId,
          });
        }
      } else if (reqdoclogListState.isFailure) {
        alert(reqdoclogListState.error?.message);
        dispatch(reqdoclogListSlice.actions.clearAsyncState());
      }
    }
  }, [reqdoclogListState, dispatch]);

  const handleOnUploaded = async () => {
    if (isDepartmentRequestDoc) {
      await dispatch(reqdoclogList({ draftId, status: "R" }));
    }
  };

  return (
    <div className={classes.root}>
      <ContentTitle
        title={`Smart Visa “${smartNameAlise}” ( ${smartNameFull} )`}
        subTitle={`APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “${smartNameAlise}”`}
      />
      <Steper currentStep={2} stepInfo={REQUEST_DOCUMENT_STEP} />
      <UploadDucument
        onUploaded={handleOnUploaded}
        setSaveDraft={setSaveDraft}
      />
    </div>
  );
}
